import * as React from "react";
import { RecentlyViewedHotelsProps, RecentlyViewedHotel } from "./typings";
import { inject } from "mobx-react";
import IsomorphicCarousel from "src/components/shared/IsomorphicCarousel/IsomorphicCarousel";
import { ItemKeyHelper } from "src/components/utility/ItemKeyHelper";
import { RecentlyViewedHotelCard } from "./components/RecentlyViewedHotelCard";
import { TrackedLink } from "components/utility/analytics/TrackedLink";
import { isVariantEnabled, Experiment } from "src/components/utility/experiment";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkLink } from "uitk-react-link";
import { HotelsStore } from "src/stores/HotelsStore";
import { UitkHeading } from "uitk-react-text";

export const RecentlyViewedHotels = inject("hotels")((props: RecentlyViewedHotelsProps) => {
  const { flexComponent, context } = props;
  const { model, id, fmId, fmTitleId } = flexComponent;
  const { formatText } = useLocalization();
  const hotels: HotelsStore = props.hotels;
  const keyHelper = new ItemKeyHelper("recently-viewed-hotels");
  const [recentViewedHotels, setRecentViewedHotel] = React.useState<RecentlyViewedHotel[]>([]);
  const numberOfHotelsToGet = 6;
  const carouselClassContainer = recentViewedHotels.length < 4 ? "carouselFitItemsContainer" : "";
  const { title, seeAllLink } = model;

  const isPriceEnabled = isVariantEnabled(props.context, Experiment.Flex_HTG_Blossom_Recently_Viewed_Hotels, 1);

  /* This would be called on initial page load */
  React.useEffect(() => {
    hotels.fetchRecentlyViewedHotels(context, numberOfHotelsToGet).then(result => {
      setRecentViewedHotel(result);
    });
  }, []);

  if (!flexComponent || !recentViewedHotels || recentViewedHotels.length === 0) {
    return null;
  }

  return (
    <div
      className="RecentlyViewedHotels uitk-cell all-cell-1-1 all-y-padding-three"
      id={id}
      data-fm={fmId}
      data-fm-title-id={fmTitleId}
    >
      <UitkHeading level={2} size={600}>
        {title}
      </UitkHeading>
      <div data-testid="see-all-recently-viewed-link">
        <UitkLink>
          <TrackedLink moduleName={"recently-viewed-hotels"} href={seeAllLink} rfrr={"link"} linkName={seeAllLink}>
            {formatText("recentlyViewedHotels.seeAlllink")}
          </TrackedLink>
        </UitkLink>
      </div>
      <div className="all-b-padding-three">
        <div className={carouselClassContainer}>
          {recentViewedHotels.length && (
            <IsomorphicCarousel
              itemsVisible={{
                lg: 3,
                md: 3,
                sm: 1
              }}
              pageBy={1}
              peekWidth={50}
              buttonText={{
                nextButton: formatText("carousel.item.next"),
                prevButton: formatText("carousel.item.prev")
              }}
            >
              {recentViewedHotels.map((hotel: RecentlyViewedHotel, index: number) => (
                <RecentlyViewedHotelCard
                  key={keyHelper.next()}
                  cardIndex={index}
                  {...hotel}
                  isPriceEnabled={isPriceEnabled}
                />
              ))}
            </IsomorphicCarousel>
          )}
        </div>
      </div>
    </div>
  );
});

export default RecentlyViewedHotels;
